module.exports = __webpack_public_path__ + "static/media/logo_bp.f63be9b7.webp";